export default "/apps/maps/img/marker-icon-2x.png";